/* eslint-disable */
export default {
  ru: [
    {
      title: 'Работа с&nbsp;резюме',
      items: [
        {
          label: 'Лимит количества кандидатов в&nbsp;базе',
          hint: '<p>Сохраняйте в&nbsp;Хантфлоу резюме кандидатов: это поможет начинать работу по&nbsp;вакансии не&nbsp;с&nbsp;нуля, а&nbsp;с&nbsp;тех специалистов, с&nbsp;которыми у&nbsp;вас уже есть история взаимодействия.</p>',
          options: [Infinity, Infinity, Infinity],
        },
        {
          label: 'Бесплатный перенос базы резюме из&nbsp;файла Эксель',
          hint:
            '<p>Продолжайте работу с&nbsp;уже знакомыми кандидатами в&nbsp;Хантфлоу: мы&nbsp;бесплатно перенесем вашу базу кандидатов из&nbsp;таблицы Эксель размером до&nbsp;15&nbsp;МБ.</p>' +
            '<p>В&nbsp;Хантфлоу будут перенесены: ФИО кандидата, его контакты (номер телефона, эл. почта, Телеграм и&nbsp;Скайп), должность и&nbsp;компания, зарплатные ожидания, дата рождения и&nbsp;ваш комментарий.</p>',
          options: [true, true, true],
        },
        {
          label: 'Сохранение резюме с&nbsp;джоб-сайтов и&nbsp;соцсетей',
          hint:
            '<p>Сохранение резюме одним кликом с&nbsp;джоб-сайтов: HeadHunter, Superjob, LinkedIn, Авито, Хабр.Карьера, Зарплата.ру, JobLab, Rabota.ua, Work.ua.</p>' +
            '<p>Из&nbsp;IT-ресурсов: GitHub, AmazingHiring, Podbor.io, Artstation, Behance, Dribbble, DeviantArt.</p>' +
            '<p>Моментальное определение дубликатов резюме и&nbsp;взятие на&nbsp;вакансию.</p>' +
            '<p><a href="https://huntflow.media/new-volshebnaya-knopka/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Распознавание резюме из&nbsp;файлов PDF, DOCX, RTF, TXT',
          hint: '<p>Распознавание резюме из&nbsp;текстового файла с&nbsp;технологией Huntflow Face Detection, которая добавит в&nbsp;профиль кандидата только фотографию кандидата, а&nbsp;картинку из&nbsp;файла, например, с&nbsp;логотипом кадрового агентства не&nbsp;добавит.</p>',
          options: [true, true, true],
        },
        {
          label: 'Импорт резюме из&nbsp;почты',
          hint:
            '<p>Пересылайте полученные письма с&nbsp;приложенными файлами с&nbsp;резюме на&nbsp;специальный адрес. Хантфлоу распознает каждое из&nbsp;резюме, добавит в&nbsp;базу и&nbsp;уведомит вас о&nbsp;результатах импорта.</p>' +
            '<p>Защита от&nbsp;спама: функция работает только для рекрутеров вашей компании.</p>',
          options: [true, true, true],
        },
        {
          label: 'Определение дубликатов резюме с&nbsp;учетом латиницы',
          hint:
            '<p>Хантфлоу определяет дубликаты не&nbsp;только по&nbsp;адресу&nbsp;эл. почты или телефону, как все другие программы. Хантфлоу определяет дубликаты еще и&nbsp;по&nbsp;ФИО кандидатов, сопоставляя информацию с&nbsp;датой рождения.</p>' +
            '<p>При этом для Хантфлоу неважно как написаны слова в&nbsp;имени. Например, написания Михаил, Mihail или Mikhail, Иванов или Ivanov Хантфлоу считает идентичными, что полезно при сохранении кандидатов из&nbsp;LinkedIn, GitHub и&nbsp;др.</p>',
          options: [true, true, true],
        },
        {
          label: 'Отмена объединения резюме',
          hint: '<p>Если вы&nbsp;случайно объединили разные резюме, то&nbsp;в&nbsp;Хантфлоу можно отменить ошибочное объединение. Резюме и&nbsp;история работы останутся у&nbsp;первоначальных кандидатов и&nbsp;не&nbsp;будут смешаны.</p>',
          options: [true, true, true],
        },
        {
          label: 'Метки кандидатов для формирования кадрового резерва',
          hint: '<p>Метки в&nbsp;Хантфлоу&nbsp;&mdash; отличный способ формирования кадрового резерва. Создайте справочник меток и&nbsp;отмечайте кандидатов по&nbsp;навыкам или уровню компетенций. А&nbsp;потом за&nbsp;секунду находите их&nbsp;в&nbsp;поиске по&nbsp;меткам.</p>',
          options: [true, true, true],
        },
        {
          label: 'Инструменты поиска по&nbsp;вашей базе резюме',
          hint:
            '<p>Полнотекстовый поиск по&nbsp;имени, контактам и&nbsp;всему тексту резюме. Указание области поиска: везде, опыте работы, в&nbsp;образовании, в&nbsp;желаемой должности. Поиск по&nbsp;меткам, вакансиям и&nbsp;источникам.</p>' +
            '<p>Уникальный поиск &laquo;Был на&nbsp;этапе&raquo; позволяет закрывать вакансии &laquo;теплыми&raquo; кандидатами, которые сейчас в&nbsp;&laquo;Отказе&raquo; или на&nbsp;любом другом этапе, но&nbsp;ранее они дошли до&nbsp;определенного этапа&nbsp;&mdash; например, финального интервью или оффера.</p>',
          options: [true, true, true],
        },
        {
          label: 'Булевый поиск (логические операторы)',
          hint:
            '<p>Эффективное использование накопленного кадрового резерва влияет на&nbsp;два ключевых показателя: скорость и&nbsp;стоимость закрытия вакансий. Если в&nbsp;первую очередь обращаться к&nbsp;кандидатам, с&nbsp;которыми вы&nbsp;уже когда-то общались, то&nbsp;подбор ускоряется и&nbsp;становится дешевле в&nbsp;несколько раз.</p>' +
            '<p>Используйте логические операторы AND, OR, NOT, () и &quot;&quot;, чтобы найти кандидата с&nbsp;нужным сочетанием навыков в&nbsp;резюме.</p>' +
            '<p><a href="https://huntflow.media/huntflow-boolean-search/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Интеграция с&nbsp;VCV',
          hint:
            '<p>Бесшовная отправка одним кликом кандидатов на&nbsp;видеоинтервью для клиентов сервиса VCV. Когда кандидат запишет видеоинтервью Хантфлоу автоматически переместит кандидата на&nbsp;этап &laquo;Видеоинтервью пройдено&raquo;, запишет ссылку на&nbsp;просмотр видеоинтервью и&nbsp;уведомит рекрутера.</p>' +
            '<p>Хантфлоу и&nbsp;VCV официальные партнеры: для всех клиентов Хантфлоу интеграция бесплатна и&nbsp;с&nbsp;нашей стороны, и&nbsp;со&nbsp;стороны VCV.</p>' +
            '<p><a href="https://huntflow.media/novinka-huntflow-vcv/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Работа с&nbsp;вакансиями',
      items: [
        {
          label: 'Публикация на&nbsp;джоб-сайтах и&nbsp;сбор откликов',
          hint: '<p>Публикуйте вакансии из&nbsp;Хантфлоу на&nbsp;HeadHunter, SuperJob, Хабр.Карьере, Авито Работе и&nbsp;Работе.ру.</p>',
          options: [true, true, true],
        },
        {
          label: 'Встроенный карьерный сайт',
          hint: '<p>Собирайте отклики из&nbsp;соцсетей и&nbsp;мессенджеров с&nbsp;помощью встроенного карьерного сайта с&nbsp;названием, логотипом и&nbsp;описанием вашей компании.</p>',
          options: [Infinity, Infinity, Infinity],
        },
        {
          label: 'Совместная работа рекрутеров над одной вакансией',
          hint: '<p>На&nbsp;каждую вакансию можно назначить несколько рекрутеров.</p>',
          options: [true, true, true],
        },
        {
          label: 'Прикрепление файлов к&nbsp;вакансии',
          hint: '<p>Прикрепляйте любые необходимые файлы к&nbsp;вакансии. Ограничение на&nbsp;каждый файл&nbsp;&mdash; не&nbsp;более 15&nbsp;МБ. Количество файлов&nbsp;&mdash; без ограничения.</p>',
          options: [true, true, true],
        },
        {
          label: 'Приостановка (холд) вакансии',
          hint:
            '<p>Если подбор приостановлен потому что, например, заказчик ушел в&nbsp;отпуск или появились более приоритетные позиции, приостановите вакансию с&nbsp;указанием причины.</p>' +
            '<p>Хантфлоу вычтет дни приостановки из&nbsp;общего срока работы над вакансией.</p>',
          options: [true, true, true],
        },
        {
          label: 'Выгрузка списка кандидатов',
          hint: '<p>Выгружайте список кандидатов в&nbsp;Excel с&nbsp;определенных или всех этапов вакансии, указав нужный состав выгрузки: ФИО, эл. почта, телефон, последнее место работы, зарплата, дата рождения, текущий этап подбора.</p>',
          options: [true, true, true],
        },
        {
          label: 'Формы обратной связи по&nbsp;кандидату',
          hint:
            '<p>Составьте чеклисты и&nbsp;формы обратной связи для заполнения рекрутерами и&nbsp;заказчиками после оценки резюме и&nbsp;интервью.</p>' +
            '<p>Уникальный визуальный конструктор форм с&nbsp;разнообразными типами ответов от&nbsp;текстовых до&nbsp;оценки по&nbsp;шкале. Указывайте пояснение к&nbsp;каждому полю и&nbsp;обязательность ответов.</p>' +
            '<p><a href="https://huntflow.media/formy-obratnoy-svyazi/" target="_blank">Читать подробнее</a></p>',
          options: [Infinity, Infinity, Infinity],
        },
        {
          label: 'Формирование офферов',
          hint: '<p>Формируйте оффер с&nbsp;вашим логотипом в&nbsp;файл PDF прямо из&nbsp;Хантфлоу с&nbsp;автоматическим сохранением его в&nbsp;истории работы по&nbsp;кандидату.</p>',
          options: [true, true, true],
        },
        {
          label: 'Внедрение шаблона оффера в&nbsp;корпоративном стиле клиента',
          additionalPay: true,
          hint:
            '<p>Мы&nbsp;внедрим ваш корпоративный дизайн оффера и&nbsp;все необходимые поля об&nbsp;условиях будущего трудоустройства.</p>' +
            '<p>Рекрутеры в&nbsp;несколько раз сократят затраты времени на&nbsp;формирование оффера по&nbsp;корпоративным стандартам.</p>' +
            '<p><span class="pricing-table-hint-currency"></span> Внедрение каждого индивидуального шаблона: от&nbsp;%PRICE%, единоразово, без учета НДС.</p>' +
            '<p><a href="https://huntflow.media/formirujte-brendirovannye-offery-odnim-klikom/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
          price: {
            rub: 210000,
            usd: 3100,
            eur: 2700,
            kzt: 1550000,
            uzs: 30000000,
          },
        },
        {
          label: 'Вакансии высокого приоритета',
          hint: '<p>Вакансии, отмеченные признаком &laquo;Высокий приоритет&raquo; отмечаются красным флажком и&nbsp;находятся наверху всех списков.</p>',
          options: [true, true, true],
        },
        {
          label: 'Приватная вакансия',
          hint: '<p>Иногда деликатные вакансии и&nbsp;историю работы по&nbsp;ним нужно скрывать от&nbsp;коллег. Приватные вакансии в&nbsp;Хантфлоу увидят только управляющий рекрутер (администратор) и&nbsp;те&nbsp;рекрутеры, которые назначены на&nbsp;нее.</p>',
          options: [true, true, true],
        },
        {
          label: 'Дедлайн вакансии',
          hint: '<p>Указывайте срок, до&nbsp;которого должна быть закрыта вакансия и&nbsp;Хантфлоу будет его контролировать с&nbsp;учетом производственного календаря России, Казахстана, Республики Беларусь или Украины. Целевой и&nbsp;реальный срок закрытия вакансии попадут в&nbsp;отчеты. О&nbsp;просрочке будет информировать интерфейс и&nbsp;уведомления на&nbsp;почту.</p>',
          options: [true, true, true],
        },
        {
          label: 'Автоматический расчет дедлайна вакансии с&nbsp;учетом производственного календаря',
          additionalPay: true,
          hint:
            '<p>Для компаний, у&nbsp;которых есть утвержденные целевые сроки закрытия вакансий (SLA) на&nbsp;основе категорий, грейдов или должностей по&nbsp;штатному расписанию, мы&nbsp;внедрим автоматический расчет дедлайна вакансии с&nbsp;учетом производственного календаря.</p>' +
            '<p>Пример. Рекрутер просто выберет в&nbsp;форме грейд вакансии, а&nbsp;Хантфлоу автоматически рассчитает дедлайн найма.</p>' +
            '<p>Для расчета стоимости требуется обсуждение бизнес-процесса.</p>',
          options: [null, true, true],
        },
        {
          label: 'Встроенные анкеты кандидатов',
          hint: '<p>Автоматизируйте тестовые задания, заполнение анкет для службы безопасности и&nbsp;сбор информации от&nbsp;кандидатов: создавайте анкеты и&nbsp;отправляйте их&nbsp;прямо из&nbsp;Хантфлоу. Вы&nbsp;получите уведомление, когда кандидат заполнит анкету, а&nbsp;все ответы сохранятся в&nbsp;его карточке.</p>',
          options: [null, true, true],
        },
        {
          label: 'Мультивакансия',
          hint:
            '<p>Уникальный инструмент работы с&nbsp;вакансиями с&nbsp;общими начальными этапами воронки&nbsp;&mdash; подходит и&nbsp;для массовых линейных, и&nbsp;для IT-вакансий.</p>' +
            '<p>Сначала вы&nbsp;ведете кандидата по&nbsp;общим этапам мультивакансии как обычно (статистика действий при этом автоматически записывается во&nbsp;все вложенные вакансии), а&nbsp;потом, когда определитесь с&nbsp;отделом или командой, переводите кандидата на&nbsp;этап уже по&nbsp;определенной вакансии.</p>',
          options: [null, true, true],
        },
      ],
    },
    {
      title: 'Работа с&nbsp;заказчиками',
      items: [
        {
          label: 'Лимит рабочих мест для заказчиков',
          hint:
            '<p>Взаимодействие с&nbsp;заказчиками&nbsp;&mdash; большая часть ежедневной работы рекрутера. Без глубокого вовлечения заказчиков в&nbsp;подбор сложно выстроить прозрачный и&nbsp;эффективный бизнес-процесс рекрутинга.</p>' +
            '<p>Хантфлоу предоставляет бесплатные рабочие места для заказчиков вакансий и&nbsp;сотрудников, оценивающих кандидатов. </p>' +
            '<p>Такие пользователи прямо из&nbsp;Хантфлоу подают заявки на&nbsp;подбор, оценивают кандидатов, которых вы&nbsp;им&nbsp;представили, и&nbsp;оставляют обратную связь, видят статистику работы по&nbsp;своим вакансиям.</p>',
          options: [Infinity, Infinity, Infinity],
        },
        {
          label: 'Заявка на&nbsp;подбор и&nbsp;настройка ее&nbsp;полей',
          hint:
            '<p>Упорядочивание процесса подачи заявки на&nbsp;подбор&nbsp;&mdash; важная часть выстраивания бизнес-процесса рекрутинга, которая делает заказчиков более ответственными и&nbsp;сокращает затраты рекрутеров на&nbsp;выяснение требований.</p>' +
            '<p><a href="https://huntflow.media/forma-zayavki/" target="_blank">Читать подробнее</a></p>',
          options: ['1&nbsp;форма заявки', Infinity, Infinity],
        },
        {
          label: 'Статистика для заказчика по&nbsp;вакансиям, на&nbsp;которые он&nbsp;назначен',
          hint:
            '<p>В&nbsp;Хантфлоу заказчики видят кандидатов только на&nbsp;тех этапах, которые рекрутер открыл для них. Однако обезличенную статистику&nbsp;&mdash; воронку, источники и&nbsp;отказы&nbsp;&mdash; заказчики видят полностью по&nbsp;всем этапам своих вакансий.</p>' +
            '<p>Это делает процесс рекрутинга прозрачным и&nbsp;снимает вопросы о&nbsp;работе рекрутера над вакансией.</p>',
          options: [true, true, true],
        },
        {
          label: 'Возможность скрывать зарплату от&nbsp;заказчика',
          hint:
            '<p>Хантфлоу позволяет автоматически скрывать зарплату из&nbsp;вакансии, профилей кандидатов и&nbsp;резюме, добавленных с&nbsp;помощью Волшебной кнопки.</p>' +
            '<p>Это бывает необходимо, чтобы оценка навыков кандидата была объективной или если в&nbsp;вашей компании установлена корпоративная политика скрытия зарплат.</p>',
          options: [true, true, true],
        },
        {
          label: 'Оценка рекрутмента заказчиками',
          hint:
            '<p>Каждый раз, когда рекрутер закроет позицию, автору заявки на подбор будет предложено оценить работу рекрутмента по вышедшему кандидату.</p>' +
            '<p>Это позволит узнать, как оценивают вашу работу заказчики, автоматизировать сбор обратной связи о рекрутменте, непрерывно улучшать взаимодействие с заказчиками и узнавать о проблемах взаимодействия до того, как они станут острыми.</p>',
          options: [null, true, true],
        },
        {
          label: 'План подбора на&nbsp;основе поступивших заявок',
          additionalPay: true,
          hint:
            '<p>Удобный инструмент долгосрочного планирования: все поступившие заявки группируются по&nbsp;месяцам, в&nbsp;которых требуется выход сотрудников.</p>' +
            '<p>При внедренном автоматическом расчете дедлайна вакансий, в&nbsp;плане подбора отображаются даты, не&nbsp;позднее которых надо начать работу над вакансией, чтобы закрыть ее&nbsp;в&nbsp;срок по&nbsp;SLA.</p>' +
            '<p>Для расчета стоимости требуется обсуждение бизнес-процесса.</p>',
          options: [null, true, true],
        },
      ],
    },
    {
      title: 'Инструменты работы с&nbsp;почтой',
      items: [
        {
          icon: 'ai',
          additionalPay: true,
          label: 'Генерация эффективных холодных писем',
          hint:
            '<p>Хантфлоу учитывает описание вакансии, источник и&nbsp;историю взаимодействия с&nbsp;кандидатом при генерации письма.</p>' +
            '<p>Лимит генераций рассчитывается на&nbsp;каждого рекрутера отдельно и&nbsp;зависит от&nbsp;тарифа.</p>' +
            '<p><span class="pricing-table-hint-currency"></span> Каждые 50&nbsp;дополнительных генераций стоят %PRICE% на&nbsp;каждого рекрутера.</p>',
          options: ['50 в&nbsp;месяц', '100 в&nbsp;месяц', '150 в&nbsp;месяц'],
          price: {
            rub: 18000,
            usd: 365,
            eur: 295,
            kzt: 155000,
            uzs: 2550000,
          },
        },
        {
          label: 'Встроенный почтовый клиент для отправки писем кандидатов через рабочую почту рекрутера',
          hint:
            '<p>Отправка писем кандидатам парой кликов прямо из&nbsp;Хантфлоу через вашу рабочую почту, по&nbsp;шаблону или без.</p>' +
            '<p>Больше не&nbsp;нужно копировать письма и&nbsp;ответы кандидатов из&nbsp;другой программы! Отправленные письма сохраняются и&nbsp;в&nbsp;почте рекрутера, и&nbsp;в&nbsp;Хантфлоу. Важная деталь: ответы кандидата тоже автоматически приходят и&nbsp;в&nbsp;почту рекрутера, и&nbsp;в&nbsp;Хантфлоу.</p>',
          options: [true, true, true],
        },
        {
          label: 'Шаблоны писем с&nbsp;возможностью прикрепления к&nbsp;ним файлов',
          hint:
            '<p>Создавайте шаблоны писем с&nbsp;переменными, которые Хантфлоу будет автоматически заменять именем кандидата, названием вакансии, датой и&nbsp;временем собеседования и&nbsp;др.</p>' +
            '<p>Прикрепляйте к&nbsp;шаблону необходимые файлы, например, с&nbsp;тестовым заданием или схемой проезда.</p>' +
            '<p>Число шаблонов&nbsp;&mdash; без ограничений!</p>',
          options: [true, true, true],
        },
        {
          label: 'Шаблон подписи рекрутера',
          hint: '<p>Один раз создайте свою подпись (можно даже с&nbsp;логотипом и&nbsp;ссылками!) и&nbsp;используйте ее&nbsp;во&nbsp;всех письмах кандидата.</p>',
          options: [true, true, true],
        },
        {
          label: 'Автоматические повторные письма, если кандидат не&nbsp;отвечает',
          hint:
            '<p>Часто кандидаты отвечают только на&nbsp;2 или 3 письмо. В&nbsp;Хантфлоу рекрутеры настраивают цепочки автоматических повторных писем, которые отправляются через заданное число дней, если кандидат не&nbsp;отвечает. При этом, кандидат не&nbsp;узнает, что письма отправлены роботом.</p>' +
            '<p><a href="https://huntflow.media/uvelichte-na-25-konversiyu-holodnyh-pisem-kandidatam/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Отложенная отправка писем',
          hint:
            '<p>Отложенная отправка писем позволяет рекрутеру написать кандидату сейчас, а&nbsp;отправить в&nbsp;будущем в&nbsp;нужное время. Например, когда есть разница в&nbsp;часовых поясах, или если нужно, чтобы кандидат получил письмо в&nbsp;строго определенное время.</p>' +
            '<p><a href="https://huntflow.media/novinka-otlozennaya-otpravka-pisem/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Отслеживание открытия письма кандидатом',
          hint:
            '<p>Хантфлоу покажет, открыл&nbsp;ли кандидат ваше письмо. Это поможет анализировать и&nbsp;корректировать способы и&nbsp;содержание коммуникации, и&nbsp;повысит конверсию при прямом поиске.</p>' +
            '<p><a href="https://huntflow.media/novinka-otkrytie-pisma/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Отчет по&nbsp;конверсии отправленных писем',
          hint: '<p>Отчет показывает число отправленных писем, процент их&nbsp;открываемости и&nbsp;число ответов кандидатов.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Инструменты работы с&nbsp;календарем',
      items: [
        {
          label: 'Интеграция с&nbsp;рабочим календарем рекрутера',
          hint: '<p>Отправляйте собеседования себе и&nbsp;коллегам в&nbsp;рабочий календарь прямо из&nbsp;Хантфлоу, без перехода в&nbsp;другую программу.</p>',
          options: [true, true, true],
        },
        {
          label: 'Учет часового пояса каждого участника встречи',
          hint: '<p>Рекрутер указывает время по&nbsp;тому часовому поясу, в&nbsp;котором будет проводиться собеседование, а&nbsp;Хантфлоу отправляет каждому участнику встречу в&nbsp;календарь с&nbsp;учетом часового пояса этого участника.</p>',
          options: [true, true, true],
        },
        {
          label: 'Автоматическое прикрепление резюме к&nbsp;событию',
          hint:
            '<p>Хантфлоу автоматически прикрепляет резюме кандидата к&nbsp;событию в&nbsp;календаре. У&nbsp;каждого собеседующего будет под рукой резюме кандидата для ознакомления до&nbsp;или во&nbsp;время собеседования.</p>' +
            '<p>При необходимости, Хантфлоу может автоматически скрыть зарплату из&nbsp;прикрепляемого к&nbsp;календарю резюме.</p>',
          options: [true, true, true],
        },
        {
          label: 'Двусторонняя интеграция с&nbsp;календарем Google',
          hint:
            '<p>Полная двусторонняя интеграция Хантфлоу с&nbsp;корпоративным календарем Google.</p>' +
            '<p>Синхронизация рабочих контактов и&nbsp;переговорок, поддержка приватных событий, проверка занятости коллег и&nbsp;переговорок прямо в&nbsp;Хантфлоу без переключения в&nbsp;программу-календарь (встроенный планировщик только на&nbsp;тарифах Профессиональный и&nbsp;выше).</p>' +
            '<p>Безопасное подключение рабочего календаря рекрутера одним кликом через OAuth.</p>',
          options: [true, true, true],
        },
        {
          label: 'Двусторонняя интеграция с&nbsp;календарем Outlook365',
          hint:
            '<p>Полная двусторонняя интеграция Хантфлоу с&nbsp;корпоративным календарем Outlook365.</p>' +
            '<p>Синхронизация рабочих контактов и&nbsp;переговорок, поддержка приватных событий, проверка занятости коллег и&nbsp;переговорок прямо в&nbsp;Хантфлоу без переключения в&nbsp;программу-календарь (встроенный планировщик только на&nbsp;тарифах Профессиональный и&nbsp;выше).</p>' +
            '<p>Уникальная интеграция позволяет безопасно подключать даже закрытые извне рабочие календари Outlook365 одним кликом через OAuth.</p>',
          options: [true, true, true],
        },
        {
          label: 'Двусторонняя интеграция с&nbsp;календарем Exchange',
          hint:
            '<p>Полная двусторонняя интеграция Хантфлоу с&nbsp;корпоративным календарем Exchange.</p>' +
            '<p>Синхронизация рабочих контактов и&nbsp;переговорок, поддержка приватных событий, проверка занятости коллег и&nbsp;переговорок прямо в&nbsp;Хантфлоу без переключения в&nbsp;программу-календарь (встроенный планировщик только на&nbsp;тарифах Профессиональный и&nbsp;выше).</p>' +
            '<p>Подключение по&nbsp;протоколу Exchange Web Services, возможно через Impersonation.</p>',
          options: [true, true, true],
        },
        {
          label: 'Встроенный планировщик корпоративного календаря',
          hint:
            '<p>Встроенный планировщик календаря Хантфлоу показывает занятость коллег и&nbsp;переговорок без перехода в&nbsp;рабочую программу с&nbsp;календарем. </p>' +
            '<p>Работает с&nbsp;подключенными календарями Google, Outlook365 и&nbsp;Exchange.</p>',
          options: [true, true, true],
        },
        {
          label: 'Готовая интеграция с&nbsp;Zoom, Google Meet, MS&nbsp;Teams и&nbsp;Яндекс.Телемост',
          hint: '<p>При создании нового интервью Хантфлоу автоматически создаст ссылку на&nbsp;видеовстречу в&nbsp;Zoom, Google Meet, MS&nbsp;Teams или Яндекс.Телемост. Ссылка на&nbsp;видеовстречу прикрепится ко&nbsp;встрече в&nbsp;календаре у&nbsp;всех участников и&nbsp;будет добавлена в&nbsp;приглашение кандидату по&nbsp;эл. почте, SMS или в&nbsp;Телеграм.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Мессенджеры, SMS и&nbsp;IP-телефония',
      items: [
        {
          label: 'Интеграция с&nbsp;Telegram',
          hint:
            '<p>Революционная интеграция с&nbsp;Telegram! Хантфлоу сам поищет телеграм кандидата и&nbsp;предложит отправить ему сообщение по&nbsp;шаблону или без него.</p>' +
            '<p><a href="https://huntflow.media/huntflow-telegram/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Интеграция с&nbsp;WhatsApp',
          hint:
            '<p>Пишите сообщения в&nbsp;WhatsApp кандидатам без необходимости превращать вашу телефонную книгу в&nbsp;&laquo;желтые страницы&raquo;. Хантфлоу позволяет писать сообщения в&nbsp;WhatsApp кандидатам парой кликов по&nbsp;шаблону или без него.</p>' +
            '<p><a href="https://huntflow.media/huntflow-whatsapp/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Интеграция с&nbsp;Viber',
          hint:
            '<p>Пишите сообщения в Viber кандидатам без необходимости превращать вашу телефонную книгу в «желтые страницы». Хантфлоу позволяет писать сообщения в Viber кандидатам парой кликов. Требуется установленное на компьютер приложение Viber.</p>' +
            '<p><a href="https://huntflow.media/huntflow-viber/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Отправка SMS кандидатам',
          hint:
            '<p>Отправляйте приглашения на&nbsp;вакансию и&nbsp;любые другие SMS-сообщения кандидату по&nbsp;заранее установленным шаблонам с&nbsp;переменными или без.</p>' +
            '<p>Подключение бесплатное; требуется заключение прямого договора с&nbsp;QuickTelecom или Rapporto.</p>' +
            '<p><a href="https://huntflow.media/kak-povysit-na-40-dohodimost-do-sobesedovanij/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Автоматические SMS-напоминания кандидатам об&nbsp;интервью',
          hint:
            '<p>Автоматические напоминания кандидатам о&nbsp;предстоящем собеседовании повысят доходимость до&nbsp;40%.</p>' +
            '<p>Подключение бесплатное; требуется заключение прямого договора с&nbsp;QuickTelecom или Rapporto.</p>' +
            '<p><a href="https://huntflow.media/kak-povysit-na-40-dohodimost-do-sobesedovanij/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Интеграция с&nbsp;IP-телефонией VoxImplant или MangoTelecom для исходящих звонков кандидатам',
          hint:
            '<p>Звоните кандидатам прямо из&nbsp;Хантфлоу. Длительность звонка, запись разговора или факт недозвона будут сохранены в&nbsp;истории работы с&nbsp;кандидатом.</p>' +
            '<p>Подключение бесплатное; требуется заключение прямого договора с&nbsp;VoxImplant или MangoTelecom.</p>',
          options: [true, true, true],
        },
        {
          label: 'Интеграция с&nbsp;IP-телефонией Asterisk для исходящих звонков кандидатам',
          additionalPay: true,
          hint:
            '<p>Звоните кандидатам прямо из&nbsp;Хантфлоу. Длительность звонка, запись разговора или факт недозвона будут сохранены в&nbsp;истории работы с&nbsp;кандидатом.</p>' +
            '<p><span class="pricing-table-hint-currency"></span> Интеграция: %PRICE%, единоразово, без учета НДС. Требуется заключение прямого договора с&nbsp;Asterisk.</p>',
          options: [null, true, true],
          price: {
            rub: 240000,
            usd: 3500,
            eur: 2900,
            kzt: 1900000,
            uzs: 34000000,
          },
        },
      ],
    },
    {
      title: 'Организация бизнес-процесса',
      items: [
        {
          label: 'Настройка справочника оргструктуры',
          hint: `
            <p>Справочник оргструктуры помогает:</p>
            <p>
                <ul>
                    <li>Обеспечивать полноту информации о&nbsp;вакансии</li>
                    <li>Проводить детальную аналитику в&nbsp;разрезе каждого отдела или подразделения</li>
                    <li>Быстро находить кандидатов, которых рассматривали на&nbsp;вакансии нужных отделов</li>
                </ul>
            </p>
          `,
          options: [true, true, true],
        },
        {
          label: 'Настройка неограниченного числа этапов в&nbsp;воронке',
          hint:
            '<p>В&nbsp;Хантфлоу можно добавить неограниченное число этапов подбора.</p>' +
            '<p>Это очень важно: все этапы подбора, которые есть в&nbsp;реальном бизнес-процессе обязательно должны быть в&nbsp;рекрутинговой программе. Если воронка в&nbsp;программе отличается от&nbsp;воронки в&nbsp;жизни, то&nbsp;становится невозможно обнаружить проблемные точки процесса.</p>',
          options: [true, true, true],
        },
        {
          label: 'Настройка типовых причин отказа',
          hint:
            '<p>Добавьте все типовые причины отказа, которые встречаются в&nbsp;вашем подборе и&nbsp;в&nbsp;процессе работы пополняйте их&nbsp;список.</p>' +
            '<p>Аналитика того, по&nbsp;какой причине и&nbsp;после какого этапа мы&nbsp;отказываем кандидатам или они отказываются сами помогает обнаружить и&nbsp;исправить скрытые проблемы в&nbsp;подборе.</p>' +
            '<p>Добавление типовых причин отказа&nbsp;&mdash; без ограничений.</p>',
          options: [true, true, true],
        },
        {
          label: 'Разные воронки под разные категории вакансий',
          hint:
            '<p>Воронка простых вакансий часто короче, чем воронка профессионального или IT-подбора: здесь число этапов может достигать и&nbsp;двадцати.</p>' +
            '<p>Обязательно настройте в&nbsp;Хантфлоу разные наборы этапов (воронок) для разных вакансий&nbsp;&mdash; рекрутерам станет еще удобнее работать, а&nbsp;аналитика будет максимально точной и&nbsp;достоверной.</p>',
          options: [true, true, true],
        },
        {
          label: 'Контроль (ограничение) времени нахождения кандидата на&nbsp;каждом этапе',
          hint:
            '<p>Предотвратите &laquo;зависание&raquo; кандидатов на&nbsp;этапах и&nbsp;ускорьте их&nbsp;движение по&nbsp;воронке, установив целевые сроки нахождения кандидата на&nbsp;каждом из&nbsp;этапов.</p>' +
            '<p><a href="https://huntflow.media/novinka-srok-na-etape/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Внедрение дополнительных полей и&nbsp;справочников вакансии',
          hint: '<p>Внедрим необходимые поля в&nbsp;форму вакансии, например, &laquo;Грейды&raquo;, &laquo;Категория вакансии&raquo;, &laquo;Проект&raquo;, &laquo;Команда&raquo; и&nbsp;др. для полноты информации о&nbsp;вакансии и&nbsp;удобной фильтрации по&nbsp;ним в&nbsp;дашборде и&nbsp;статистике.</p>',
          options: [true, true, true],
        },
        {
          label: 'Внедрение дополнительных полей и&nbsp;справочников в&nbsp;карточку кандидата',
          hint: '<p>Внедрим необходимые поля в&nbsp;карточку кандидата, например, &laquo;Какую з/п на&nbsp;прошлом месте работы назвал на&nbsp;интервью&raquo;, &laquo;Откуда узнал о&nbsp;вакансии&raquo; и&nbsp;др.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Рекрутеры и&nbsp;их&nbsp;права',
      items: [
        {
          label: 'Запрет удаления вакансий и&nbsp;кандидатов',
          hint: '<p>Ограничьте рекрутеру возможность удалять кандидатов, а&nbsp;также удалять и&nbsp;управлять вакансиями.</p>',
          options: [true, true, true],
        },
        {
          label: 'Скрытие истории работы по&nbsp;вакансиям от&nbsp;рекрутера',
          hint:
            '<p>Ограничение &laquo;Видит только свои вакансии&raquo; скроет вакансии и&nbsp;историю работы с&nbsp;кандидатами по&nbsp;всем вакансиям, кроме тех, которые ведет этот рекрутер.</p>' +
            '<p>При этом база кандидатов будет доступна полностью, дубликаты будут определяться и&nbsp;Хантфлоу укажет, у&nbsp;какого именно рекрутера в&nbsp;работе тот или иной кандидат по&nbsp;недоступной вакансии.</p>',
          options: [true, true, true],
        },
        {
          label: 'Возможность назначения нескольких Управляющих в&nbsp;Хантфлоу',
          hint:
            '<p>Роль Управляющего рекрутера&nbsp;&mdash; это роль администратора. Управляющий управляет списком и&nbsp;правами рекрутеров, всеми настройками компании: этапами подбора, источниками резюме и&nbsp;др.</p>' +
            '<p>При необходимости, права Управляющего могут быть даны нескольких рекрутерам организации.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Работа с&nbsp;персональными данными кандидатов',
      items: [
        {
          label: 'Модуль онлайн-запроса согласия кандидата на&nbsp;обработку ПД&nbsp;одним кликом',
          hint:
            "<p>Отправка одним кликом брендированного письма кандидатам с&nbsp;рабочей почты рекрутера с&nbsp;автоматизированным запросом согласия на&nbsp;обработку персональных данных<span class='js-pricing-table-hint-ru'> в&nbsp;соответствии с&nbsp;152-ФЗ</span>. В&nbsp;письмо мы&nbsp;бесплатно внедряем текст согласия, предоставленный юристами клиента.</p>" +
            '<p><a href="https://huntflow.media/nasha-novinka-modul-personalnyh-dannyh/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Ваш логотип в&nbsp;письме-запросе',
          hint: '<p>Письмо с&nbsp;запросом согласия брендируется логотипом клиента.</p>',
          options: [true, true, true],
        },
        {
          label: 'Выгрузка в&nbsp;Excel отчета по&nbsp;согласиям на&nbsp;обработку&nbsp;ПД',
          hint: '<p>Отчет по&nbsp;кандидатам, которые не&nbsp;дали решения или запретили обрабатывать персональные данные.</p>',
          options: [true, true, true],
        },
        {
          label: 'Опции автоматического запроса согласия и&nbsp;автоматического удаления',
          hint:
            '<p>Возможность автоматической отправки запроса кандидата при добавлении в&nbsp;базу без необходимости для рекрутера нажатия на&nbsp;кнопку отправки.</p>' +
            '<p>Возможность автоматического удаления кандидатов, не&nbsp;давших согласие или запретивших обработку персональных данных, без необходимости для рекрутера нажатия на&nbsp;кнопку удаления.</p>',
          options: [true, true, true],
        },
        {
          label: 'Внедрение индивидуального шаблона письма с&nbsp;запросом',
          additionalPay: true,
          hint:
            '<p>Для клиентов, которые хотят, чтобы кандидат получал письмо в&nbsp;индивидуальном дизайне мы&nbsp;меняем внешний вид письма на&nbsp;тот, который предоставляют клиенты.</p>' +
            '<p><span class="pricing-table-hint-currency"></span> Внедрение: %PRICE%, единоразово, без учета НДС.</p>',
          options: [true, true, true],
          price: {
            rub: 90000,
            usd: 1400,
            eur: 1200,
            kzt: 690000,
            uzs: 12500000,
          },
        },
      ],
    },
    {
      title: 'Аналитика и&nbsp;отчеты',
      items: [
        {
          label: 'Дашборд &laquo;Картина дня&raquo;',
          hint:
            '<p>Картина дня показывает все открытые вакансии, время и&nbsp;число кандидатов в&nbsp;работе и&nbsp;дедлайны. Позволяет быстро смотреть, что происходит с&nbsp;вакансиями в&nbsp;определенном отделе или у&nbsp;определенного рекрутера.</p>' +
            '<p><a href="https://huntflow.media/novinka-kartina-podbora-kak-na-ladoni/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Визуализация данных',
          hint:
            '<p>В&nbsp;Хантфлоу уникальная визуализация статистики: на&nbsp;одном экране вы&nbsp;видите всю картину по&nbsp;воронке, источникам, отказам и&nbsp;их&nbsp;причинам.</p>' +
            '<p><a href="https://huntflow.media/novinka-vizualizatsiya-voronki-podbora-istochnikov-i-otkazov-na-odnom-ekrane/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Выгрузка отчетов в&nbsp;Excel',
          hint: '<p>Данные отчетов могут быть выгружены в&nbsp;формате Excel.</p>',
          options: [true, true, true],
        },
        {
          label: 'Отчеты по&nbsp;воронке, источникам, отказам',
          hint: '<p>Отчеты показывают: движение кандидатов по&nbsp;воронке, источники добавления кандидатов и&nbsp;причины отказов, по&nbsp;которым диалог с&nbsp;кандидатом прекратился.</p>',
          options: [true, true, true],
        },
        {
          label: 'Отчет по&nbsp;времени закрытия позиции',
          hint: '<p>Отчет показывает сколько позиций и&nbsp;какими кандидатами было закрыто, в&nbsp;какой срок с&nbsp;учетом производственного календаря и&nbsp;какими рекрутерами.</p>',
          options: [true, true, true],
        },
        {
          label: 'Отчет по&nbsp;времени нахождения кандидата на&nbsp;каждом этапе',
          hint:
            '<p>Отчет показывает, сколько времени кандидаты находились на&nbsp;каждом этапе воронки. Это помогает найти и&nbsp;отработать точки &laquo;зависания&raquo; кандидатов у&nbsp;рекрутера или заказчика.</p>' +
            '<p>Детализация показывает в&nbsp;течение какого времени и&nbsp;какие именно кандидаты находились на&nbsp;каждом этапе подбора до&nbsp;найма.</p>',
          options: [true, true, true],
        },
        {
          label: 'Углубленная аналитика с&nbsp;помощью детализации по&nbsp;кандидатам',
          hint: '<p>Каждый сегмент визуализации отчетов становится интерактивен. При нажатии на&nbsp;него Хантфлоу покажет список кандидатов, которые в&nbsp;него входят. Вы&nbsp;увидите, кто из&nbsp;кандидатов завис на&nbsp;этапе, а&nbsp;кто именно принял контроффер и&nbsp;сможете перейти в&nbsp;карточки этих кандидатов для качественного анализа ситуации.</p>',
          options: [true, true, true],
        },
        {
          label: 'Отчет по&nbsp;конверсии писем кандидатам',
          hint: '<p>Отчет показывает число отправленных писем, процент их&nbsp;открываемости и&nbsp;число ответов кандидатов.</p>',
          options: [true, true, true],
        },
        {
          label: 'Отчет по&nbsp;движению кандидатов',
          hint:
            '<p>Закрытие любой вакансии&nbsp;&mdash; это движение рекрутером кандидатов по&nbsp;воронке. Каждый день. Нет движений&nbsp;&mdash; нет закрытия. Отчет по&nbsp;движению покажет ежедневный прогресс рекрутеров по&nbsp;закрытию вакансий.</p>' +
            '<p>Управление подбором невозможно без контроля движений кандидатов.</p>',
          options: [null, true, true],
        },
        {
          label: 'Отчет по оценке рекрутмента заказчиками',
          hint: '<p>Отчет показывает как заказчики оценивают работу отдела подбора и&nbsp;конкретных рекрутеров (аналог оценки NPS).</p>',
          options: [null, true, true],
        },
      ],
    },
    {
      title: 'Забота и&nbsp;уют',
      items: [
        {
          label: 'Чат поддержки прямо в&nbsp;интерфейсе',
          hint:
            '<p>Отвечаем за&nbsp;несколько минут в&nbsp;чате поддержки прямо в&nbsp;интерфейсе Хантфлоу по&nbsp;будням с&nbsp;9&nbsp;до&nbsp;19 (МСК).</p>' +
            '<p>В&nbsp;общем чате вместе с&nbsp;менеджерами службы заботы Хантфлоу&nbsp;&mdash; все рекрутеры клиента, которые видят вопросы своих коллег. Это избавляет рекрутеров от&nbsp;необходимости каждому задавать одинаковые вопросы.</p>',
          options: [true, true, true],
        },
        {
          label: 'Приложение-АОН для iPhone',
          hint: '<p>Приложение для iPhone определит и&nbsp;прямо на&nbsp;экране входящего звонка (и&nbsp;в&nbsp;списке пропущенных) покажет имя звонящего вам кандидата, если он&nbsp;есть в&nbsp;вашем Хантфлоу.</p>',
          options: [true, true, true],
        },
        {
          label: 'Напоминания о&nbsp;днях рождения кандидатов по&nbsp;вашим открытым вакансиям',
          hint: '<p>Хантфлоу раз в&nbsp;день присылает письмо с&nbsp;напоминанием о&nbsp;днях рождения кандидатов на&nbsp;ваших открытых вакансиях. Вы&nbsp;сможете проявить внимание и&nbsp;повысить шансы на&nbsp;оффер.</p>',
          options: [true, true, true],
        },
        {
          label: 'Темы оформления интерфейса',
          hint:
            '<p>Сделайте Хантфлоу по-настоящему уютным и&nbsp;своим! Выберите тему оформления интерфейса себе по&nbsp;вкусу и&nbsp;настроению.</p>' +
            '<p><a href="https://huntflow.media/new-themes-huntflow/" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Брендирование Хантфлоу вашим корпоративным стилем',
          additionalPay: true,
          hint:
            '<p>Брендированный вашим фирменным стилем Хантфлоу наделяет ежедневное рабочее пространство рекрутеров и&nbsp;заказчиков индивидуальностью вашей компании и&nbsp;пропитывает его корпоративным духом. У&nbsp;всех новых пользователей по&nbsp;умолчанию выбирается ваша брендированная тема оформления. Логотип в&nbsp;верхнем левом углу навсегда меняется на&nbsp;логотип вашей компании, даже если рекрутер сменит тему оформления на&nbsp;одну из&nbsp;встроенных в&nbsp;Хантфлоу.</p>' +
            '<p><span class="pricing-table-hint-currency"></span>&nbsp;Внедрение: %PRICE%, единоразово, без учета НДС.</p>',
          options: [true, true, true],
          price: {
            rub: 490000,
            usd: 6900,
            eur: 5900,
            kzt: 3490000,
            uzs: 69000000,
          },
        },
      ],
    },
    {
      title: 'Безопасность',
      items: [
        {
          label: 'Бесплатная выгрузка базы при прекращении сотрудничества',
          hint:
            '<p>Бесплатный возврат базы клиента при прекращении сотрудничества&nbsp;&mdash; наша обязанность по&nbsp;договору.</p>' +
            '<p>Формат возврата базы на&nbsp;выбор клиента: в&nbsp;универсальном компьютерном формате JSON со&nbsp;всеми связями, записями и&nbsp;хронологией, или&nbsp;же выгрузка всех резюме в&nbsp;PDF или DOCX.</p>',
          options: [true, true, true],
        },
        {
          label: 'Бесплатная резервная выгрузка базы по&nbsp;запросу клиента',
          hint: '<p>Бесплатная выгрузка базы в&nbsp;формате JSON по&nbsp;запросу клиента, но&nbsp;не&nbsp;чаще 1&nbsp;раза в&nbsp;квартал.</p>',
          options: [true, true, true],
        },
        {
          label: 'Автоматическое резервное копирование базы клиента на SFTP',
          hint: '<p>Организация автоматической ежедневной, еженедельной, ежемесячной или ежеквартальной выгрузки вашей базы в&nbsp;формате JSON на&nbsp;предоставленный вами SFTP-сервер.</p>',
          options: [null, true, true],
        },
        {
          label: 'Оповещение о&nbsp;массовом скачивании резюме сотрудником компании',
          hint: '<p>Хантфлоу заботится о&nbsp;безопасности ваших данных. Для предотвращения кражи базы резюме сотрудником компании, настройте в&nbsp;Хантфлоу суточные лимиты на&nbsp;скачивание, печать и&nbsp;отправку резюме на&nbsp;эл. почту.</p>',
          options: [null, true, true],
        },
      ],
    },
    {
      title: 'API Хантфлоу',
      items: [
        {
          label: 'API',
          hint:
            '<p>Публичный API дает неограниченные возможности интеграции Хантфлоу с&nbsp;внутренними сервисами компании силами разработчиков вашей компании.</p>' +
            '<p>С&nbsp;помощью Хантфлоу API клиенты реализуют интеграции с&nbsp;1С, Jira, Slack, карьерным сайтом и&nbsp;др.</p>' +
            '<p><a href="https://huntflow.ru/api" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Webhooks',
          hint:
            '<p>Вебхуки&nbsp;&mdash; интеграционный инструмент, который отправляет данные на&nbsp;внешний URL по&nbsp;определенному триггеру.</p>' +
            '<p>Предназначен для решения задач вида &laquo;Когда рекрутер перевел кандидата на&nbsp;этап &bdquo;Оффер принят&ldquo; автоматически отправляй в&nbsp;1C&nbsp;информацию по&nbsp;вакансии и&nbsp;кандидату&raquo;.</p>' +
            '<p><a href="https://github.com/huntflow/api/blob/master/ru/webhooks.md" target="_blank">Читать подробнее</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Песочница для тестирования разработанных интеграций',
          hint: '<p>Предоставление облачной среды для безопасного тестирования интеграций разработчиками клиента.</p>',
          options: [true, true, true],
        },
        {
          label: 'Методы API для автоматического добавления и&nbsp;удаления пользователей',
          additionalPay: true,
          hint:
            '<p>Предоставление разработчикам клиента методов API для синхронизации пользователей на&nbsp;основе идентификаторов из&nbsp;внутренней системы клиента.</p>' +
            '<p>Эти методы требуют размещения Хантфлоу на&nbsp;выделенном сервере и&nbsp;интеграции с&nbsp;вашей корпоративной аутентификацией.</p>' +
            '<p><span class="pricing-table-hint-currency"></span> Стоимость: %PRICE%, ежегодно.</p>',
          options: [null, null, true],
          price: {
            rub: 350000,
            usd: 4900,
            eur: 4300,
            kzt: 2500000,
            uzs: 49500000,
          },
        },
      ],
    },
    {
      title: 'Премьер: Решения для крупных корпоративных клиентов',
      items: [
        {
          label: 'Сопровождение закупочных и&nbsp;юридических процедур',
          hint: '<p>В&nbsp;крупных компаниях индивидуальные процедуры приобретения IT-решений. Мы&nbsp;заполняем необходимые анкеты и&nbsp;чек-листы, работаем по&nbsp;индивидуальным договорам, вырабатываем персональные условия и&nbsp;по&nbsp;приглашению выступаем в&nbsp;закупочных комитетах.</p>',
          options: [null, null, true],
        },
        {
          label: 'Индивидуальные IT-решения (Private Cloud, On-premise, SSO, зеркало, доступ к&nbsp;БД)',
          hint: `<p>Выполнение требований IT-безопасности вашей компании:</p>
                <p>
                <ul>
                  <li>Проработка технического архитектурного размещения</li>
                  <li>Размещение Хантфлоу на&nbsp;выделенных серверах в&nbsp;нашем или вашем дата-центре</li>
                  <li>Интеграция с&nbsp;корпоративной аутентификацией</li>
                  <li>Прохождение IT-аудита и&nbsp;penetration tests</li>
                  <li>Разворачивание и&nbsp;поддержка зеркала для тестирования внедрений и&nbsp;интеграций</li>
                  <li>Доступ к&nbsp;базе данных вашего Хантфлоу для работы аналитиков</li>
                <ul></p>`,
          options: [null, null, true],
        },
        {
          label: 'Проведение воркшопа для составления оптимального плана внедрения Хантфлоу',
          hint: `<p>Мы&nbsp;организуем воркшоп, в&nbsp;котором с&nbsp;нашей стороны будут присутствовать менеджер по&nbsp;внедрению, менеджер проектов, IT-специалист, результатом которого станет утвержденные архитектура проекта и&nbsp;план запуска с&nbsp;датами и&nbsp;учетом рисков.</p>`,
          options: [null, null, true],
        },
        {
          label: 'Разделение рекрутеров на&nbsp;команды',
          hint: '<p>Хантфлоу позволяет объединять рекрутеров в&nbsp;команды, у&nbsp;которых есть свой тим-лид. Это нужно для удобной фильтрации рекрутеров в&nbsp;дашборде и&nbsp;статистике.</p>',
          options: [null, null, true],
        },
        {
          label: 'Ограничение доступа к&nbsp;информации в&nbsp;зависимости от&nbsp;подразделения',
          hint:
            '<p>Для каждого рекрутера можно указать департамент или подразделение, в&nbsp;которое он&nbsp;подбирает сотрудников.</p>' +
            '<p>Рекрутер будет видеть заявки, вакансии, заказчиков и&nbsp;шаблоны писем только этого подразделения, не&nbsp;выбирая их&nbsp;из&nbsp;большого списка всей компании.</p>',
          options: [null, null, true],
        },
        {
          label: 'Персональный аккаунт-менеджер',
          hint: '<p>Вопросы сотрудничества обсуждаются с&nbsp;закрепленным персональным аккаунт-менеджером</p>',
          options: [null, null, true],
        },
        {
          label: 'Приоритетная расширенная поддержка пользователей',
          hint: '<p>Ответы на&nbsp;вопросы рекрутеров во&nbsp;встроенном чате или по&nbsp;эл. почте с&nbsp;первым приоритетом и&nbsp;в&nbsp;расширенном временном диапазоне с&nbsp;6&nbsp;до&nbsp;22&nbsp;МСК</p>',
          options: [null, null, true],
        },
        {
          label: 'Выделенная линия для технических консультаций по&nbsp;API',
          hint: '<p>Персональные консультации ваших разработчиков по&nbsp;наилучшей архитектуре интеграций и&nbsp;использованию API Хантфлоу</p>',
          options: [null, null, true],
        },
      ],
    },
  ],
  en: [
    {
      title: 'Working with CVs',
      items: [
        {
          label: 'Free CV&nbsp;database transfer from Excel',
          hint:
            '<p>Keep working with the candidates you already know: we&rsquo;ll transfer to&nbsp;Huntflow your&nbsp;CV database from an&nbsp;Excel spreadsheet up&nbsp;to&nbsp;15&nbsp;MB in&nbsp;size for free.</p>' +
            '<p>The following information will be&nbsp;transferred to&nbsp;Huntflow: first and last name of&nbsp;the candidate, contacts (phone number, e-mail, Telegram and Skype nicknames), previous position and company, salary expectations, date of&nbsp;birth and your comment.</p>',
          options: [true, true, true],
        },
        {
          label: 'Download CVs from job sites and social media',
          hint:
            '<p>Download CVs with just one click from social media and other platforms: Facebook, LinkedIn, GitHub, AmazingHiring, Artstation, Behance, Dribbble, DeviantArt.</p>' +
            '<p>Instantly find duplicate CVs and add to vacancies.</p>',
          options: [true, true, true],
        },
        {
          label: 'Text recognition for PDF, DOCX, RTF, TXT files',
          hint: '<p>CV&nbsp;recognition from text files using Huntflow Face Detection technology that adds the candidate&rsquo;s photo to&nbsp;their profile.</p>',
          options: [true, true, true],
        },
        {
          label: 'Import CVs from email',
          hint:
            '<p>Forward received letters with attached CVs to&nbsp;a&nbsp;special email address. Huntflow will recognise each&nbsp;CV, add it&nbsp;to&nbsp;the database, and notify you of&nbsp;the results.</p>' +
            '<p>Anti-spam protection: this feature works only for your company&rsquo;s recruiters.</p>',
          options: [true, true, true],
        },
        {
          label: 'Find duplicate CVs',
          hint:
            '<p>Huntflow goes beyond other software that only finds duplicates by&nbsp;reference to&nbsp;email addresses or&nbsp;phone numbers.</p>' +
            '<p>Huntflow finds duplicates using the candidates&rsquo; full names and comparing information on&nbsp;their dates of&nbsp;birth.</p>',
          options: [true, true, true],
        },
        {
          label: 'Cancel CV&nbsp;merge',
          hint: '<p>If&nbsp;you ever accidentally merge two different CVs, Huntflow gives you the option of&nbsp;reversing the merger. Their CVs and work history will remain with the original candidates and won&rsquo;t be&nbsp;mixed&nbsp;up.</p>',
          options: [true, true, true],
        },
        {
          label: 'Candidate tags to&nbsp;create a&nbsp;candidate pool',
          hint: '<p>Huntflow&rsquo;s tags are an&nbsp;excellent method for creating a&nbsp;candidate pool. Create a&nbsp;directory of&nbsp;tags and tag the candidates by&nbsp;skills or&nbsp;level of&nbsp;competence. From there, it&nbsp;will only take you a&nbsp;second to&nbsp;find them through a&nbsp;tag search.</p>',
          options: [true, true, true],
        },
        {
          label: 'Search tools for your&nbsp;CV database',
          hint:
            '<p>A&nbsp;full-text search by&nbsp;name, contact details and the whole body of&nbsp;the CV. Specification by&nbsp;search areas: all areas, work experience, education, desired position. Search by&nbsp;tags, vacancies, and sources.</p>' +
            '<p>The unique &laquo;former candidate&raquo; search option helps to&nbsp;fill vacancies with &laquo;warm&raquo; candidates currently at&nbsp;the &laquo;rejection&raquo; or&nbsp;other stage of&nbsp;the recruitment process who have previously reached a&nbsp;specific stage, such as&nbsp;a&nbsp;final interview or&nbsp;a&nbsp;job offer.</p>',
          options: [true, true, true],
        },
        {
          label: 'Boolean search (logical operators)',
          hint:
            '<p>Effective use of&nbsp;the accumulated candidate pool has a&nbsp;positive impact on&nbsp;the two key parameters: the speed and cost of&nbsp;filling vacancies. If&nbsp;you turn first to&nbsp;the candidates you have already communicated with at&nbsp;some point, the recruitment process is&nbsp;accelerated and becomes several times cheaper.</p>' +
            '<p>Use the logical operators AND, OR, NOT, () and &quot;&quot; to&nbsp;find the candidate with the required combination of&nbsp;skills.</p>',
          options: [true, true, true],
        },
        {
          label: 'Built-in candidate questionnaires',
          hint: '<p>Automate test assignments and candidate data collection: create questionnaires and send them directly from Huntflow. You&rsquo;ll be&nbsp;notified when a&nbsp;candidate fills out a&nbsp;questionnaire, and all answers will be&nbsp;saved in&nbsp;their card.</p>',
          options: [null, true, true],
        },
      ],
    },
    {
      title: 'Working with vacancies',
      items: [
        {
          label: 'Integrated career site',
          hint: '<p>Collect responses from social media and messengers using an&nbsp;integrated career page with the name, logo, and a&nbsp;description of&nbsp;your company.</p>',
          options: [Infinity, Infinity, Infinity],
        },
        {
          label: 'Joint work on&nbsp;the same vacancy by&nbsp;two and more recruiters',
          hint: '<p>Several recruiters can be&nbsp;appointed to&nbsp;each vacancy.</p>',
          options: [true, true, true],
        },
        {
          label: 'High priority vacancies',
          hint: '<p>Vacancies denoted as&nbsp;&laquo;high priority&raquo; are marked with red flags and pinned at&nbsp;the top of&nbsp;all lists.</p>',
          options: [true, true, true],
        },
        {
          label: 'Vacancy deadline',
          hint: '<p>Specify the date by&nbsp;which the vacancy must be&nbsp;filled, and Huntflow will track the deadline, factoring in&nbsp;weekends. The target date and real date of&nbsp;the vacancy closing will be&nbsp;added to&nbsp;reports. You will be&nbsp;informed about delays by&nbsp;the platform interface and email notifications.</p>',
          options: [true, true, true],
        },
        {
          label: 'Add files to&nbsp;the vacancy',
          hint: '<p>Attach any necessary files to&nbsp;a&nbsp;vacancy. Each file must be&nbsp;no&nbsp;more than 15&nbsp;MB. The number of&nbsp;files is&nbsp;unlimited.</p>',
          options: [true, true, true],
        },
        {
          label: 'Private vacancy',
          hint: '<p>Sometimes sensitive vacancies and the history of&nbsp;working on&nbsp;them need to&nbsp;be&nbsp;concealed from your colleagues. At&nbsp;Huntflow, private vacancies are only visible to&nbsp;the Managing Recruiter (administrator) and those recruiters who have been assigned to&nbsp;work on&nbsp;them.</p>',
          options: [true, true, true],
        },
        {
          label: 'Vacancy on&nbsp;hold',
          hint:
            '<p>If&nbsp;the recruitment process has been suspended due to&nbsp;the hiring manager going on&nbsp;vacation or&nbsp;the need to&nbsp;fill higher priority vacancies first, put the vacancy on&nbsp;hold and indicate the reason.</p>' +
            '<p>Huntflow will subtract the &laquo;on-hold&raquo; days from the overall period of&nbsp;work on&nbsp;this vacancy.</p>',
          options: [true, true, true],
        },
        {
          label: 'Download list of&nbsp;candidates',
          hint: '<p>Download to&nbsp;Excel a&nbsp;list of&nbsp;candidates from specific (or&nbsp;all) stages of&nbsp;the vacancy, specifying the required content: full name, email, phone number, last job, salary, date of&nbsp;birth, current stage of&nbsp;recruitment.</p>',
          options: [true, true, true],
        },
        {
          label: 'Candidate feedback forms',
          hint:
            '<p>Compile checklists and feedback forms that can be&nbsp;filled out by&nbsp;recruiters and hiring managers after assessing CVs and interviews.</p>' +
            '<p>A&nbsp;unique visual design tool for forms using all kinds of&nbsp;answer types, from written text to&nbsp;grading scales. Enter an&nbsp;explanation for each field and indicate which answers are mandatory.</p>',
          options: [Infinity, Infinity, Infinity],
        },
        {
          label: 'Generation of&nbsp;offers',
          hint: '<p>Generate an&nbsp;offer with your logo in&nbsp;a&nbsp;PDF file right from Huntflow and autosave it&nbsp;in&nbsp;the history of&nbsp;work with a&nbsp;given candidate.</p>',
          options: [true, true, true],
        },
        {
          label: 'Implementation of&nbsp;offer template using the client&rsquo;s corporate style',
          additionalPay: true,
          hint:
            '<p>We&rsquo;ll implement your corporate design for an&nbsp;offer and provide all the necessary boxes about the terms of&nbsp;future employment.</p>' +
            '<p>This will significantly reduce the time recruiters spend on&nbsp;generating an&nbsp;offer in&nbsp;line with corporate standards.</p>' +
            '<p><span class="pricing-table-hint-currency"></span> The implementation of&nbsp;each individual template comes with a&nbsp;one-time fee starting at&nbsp;%PRICE%.</p>',
          options: [true, true, true],
          price: {
            eur: 2700,
          },
        },
        {
          label: 'Multivacancy',
          hint:
            '<p>A&nbsp;unique tool for working with vacancies that have common initial stages in&nbsp;their recruitment pipeline: an&nbsp;approach that works well both for blue-collar personnel and&nbsp;IT vacancies.</p>' +
            '<p>First, you take the candidate through the common stages of&nbsp;the multivacancy (the stats for your actions are automatically recorded in&nbsp;all the attached vacancies), and once you&rsquo;ve decided on&nbsp;the department or&nbsp;the team, you move the candidate to&nbsp;the stage of&nbsp;the specific vacancy.</p>',
          options: [null, true, true],
        },
        {
          label: 'Integration with VCV',
          hint:
            '<p>For the clients of&nbsp;the VCV&nbsp;service, we&nbsp;offer a&nbsp;seamless one-click dispatch of&nbsp;candidates for video interviews. Once the candidate records a&nbsp;video interview, Huntflow automatically moves the candidate to&nbsp;the &laquo;video interview completed&raquo; stage, copies the video interview link, and notifies the recruiter.</p>' +
            '<p>Huntflow and VCV are official partners: integration is&nbsp;free of&nbsp;charge for all Huntflow clients, both on&nbsp;our side and on&nbsp;the VCV&nbsp;side.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Working with hiring managers',
      items: [
        {
          label: 'Limit of&nbsp;workplaces for hiring managers',
          hint:
            '<p>Interaction with hiring managers is&nbsp;an&nbsp;important part of&nbsp;the recruiter&rsquo;s daily work. Without the managers&rsquo; engagement in&nbsp;recruitment it&rsquo;s difficult to&nbsp;establish a&nbsp;transparent and efficient business process.</p>' +
            '<p>Huntflow provides free workplaces for hiring managers who file recruitment requests and employees who evaluate the candidates.</p>' +
            '<p>Such users can file recruitment requests, evaluate the candidates you suggest, leave feedback, and see the stats for their vacancies right at&nbsp;Huntflow.</p>',
          options: [Infinity, Infinity, Infinity],
        },
        {
          label: 'Vacancy request and its customisation',
          hint: '<p>Streamlining the process of&nbsp;filing vacancy requests is&nbsp;an&nbsp;important part of&nbsp;establishing a&nbsp;recruitment process that places greater responsibility onto hiring managers and reduces time and effort spent by&nbsp;recruiters in&nbsp;clarifying the requirements.</p>',
          options: ['1&nbsp;request form', Infinity, Infinity],
        },
        {
          label: 'Analytics for hiring managers for vacancies assigned to&nbsp;them',
          hint:
            '<p>With Huntflow, hiring managers can only see the candidates at&nbsp;the stages that have been opened for them by&nbsp;recruiters. However, the hiring managers can see anonymised analytics&nbsp;&mdash; the pipeline, sources, and rejections&nbsp;&mdash; for all stages of&nbsp;their vacancies.</p>' +
            '<p>This makes the recruitment process transparent and eliminates questions regarding the recruiter&rsquo;s work on&nbsp;the vacancy.</p>',
          options: [true, true, true],
        },
        {
          label: 'Option of&nbsp;hiding the salary from hiring managers',
          hint:
            '<p>Huntflow enables you to&nbsp;automatically hide the salary from the vacancy description, candidate profiles and CVs added by&nbsp;means of&nbsp;the Magic Button.</p>' +
            '<p>This may be&nbsp;necessary to&nbsp;ensure that evaluation of&nbsp;the candidate&rsquo;s skills is&nbsp;objective or&nbsp;if&nbsp;your company has a&nbsp;corporate policy of&nbsp;withholding salary information.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Tools for working with email',
      items: [
        {
          icon: 'ai',
          additionalPay: true,
          label: 'Generation of&nbsp;effective cold letters',
          hint:
            '<p>Huntflow uses the vacancy description, the source, and the history of&nbsp;interaction with the candidate when generating the letter.</p>' +
            '<p>The generation limit is&nbsp;set for each recruiter individually and depends on&nbsp;the pricing plan.</p>' +
            '<p><span class="pricing-table-hint-currency"></span> Every additional 50&nbsp;generations costs %PRICE% per recruiter.</p>',
          options: ['10&nbsp;per month', '50&nbsp;per month', '100&nbsp;per month', '150&nbsp;per month'],
          price: {
            eur: 295,
          },
        },
        {
          label: 'Integrated mail client that sends letters to&nbsp;candidates using the recruiter&rsquo;s work email',
          hint:
            '<p>Send letters to&nbsp;the candidates with a&nbsp;couple of&nbsp;clicks directly from Huntflow using your work email address, with or&nbsp;without a&nbsp;template.</p>' +
            '<p>You no&nbsp;longer have to&nbsp;copy letters and the candidates&rsquo; responses from another app! The sent letters are autosaved both in&nbsp;the recruiter&rsquo;s mail client and on&nbsp;Huntflow. An&nbsp;important detail: the candidate&rsquo;s responses are also automatically sent both to&nbsp;the recruiter&rsquo;s mail and to&nbsp;Huntflow.</p>',
          options: [true, true, true],
        },
        {
          label: 'Letter templates with file attachment option',
          hint:
            '<p>Create letter templates with variables that Huntflow will automatically fill in&nbsp;with the candidate&rsquo;s name, name of&nbsp;the position, date and time of&nbsp;the interview, etc.</p>' +
            '<p>Attach necessary files, such as&nbsp;a&nbsp;test assignment or&nbsp;travel directions, to&nbsp;the template.</p>' +
            '<p>The number of&nbsp;templates is&nbsp;unlimited!</p>',
          options: [true, true, true],
        },
        {
          label: 'Template for the recruiter&rsquo;s signature',
          hint: '<p>Create your signature once (you can even do&nbsp;one with a&nbsp;logo and links!) and use it&nbsp;in&nbsp;all of&nbsp;your emails to&nbsp;candidates.</p>',
          options: [true, true, true],
        },
        {
          label: 'Automatic follow-ups if&nbsp;the candidate is&nbsp;unresponsive',
          hint: '<p>Candidates often only answer a&nbsp;second or&nbsp;third letter. With Huntflow, recruiters customise the chains of&nbsp;automatic follow-ups that are sent after a&nbsp;set number of&nbsp;days if&nbsp;the candidate fails to&nbsp;respond, while the candidate remains unaware that the letters are being sent by&nbsp;a&nbsp;robot.</p>',
          options: [true, true, true],
        },
        {
          label: 'Send later feature',
          hint: '<p>The &laquo;send later&raquo; feature enables the recruiter to&nbsp;write to&nbsp;the candidate right away but send the letter later as&nbsp;needed. This is&nbsp;pertinent when there is&nbsp;a&nbsp;difference in&nbsp;time zones or&nbsp;if&nbsp;you require that the candidate receive the letter at&nbsp;a&nbsp;specific time of&nbsp;day.</p>',
          options: [true, true, true],
        },
        {
          label: 'Track whether the candidate has opened a&nbsp;letter',
          hint: '<p>Huntflow will show whether a&nbsp;candidate has opened your letter. This will help in&nbsp;analysing and correcting the methods and content of&nbsp;communication, as&nbsp;well as&nbsp;increasing conversion when you perform a&nbsp;direct search.</p>',
          options: [true, true, true],
        },
        {
          label: 'Report on&nbsp;conversion rates of&nbsp;sent letters',
          hint: '<p>The report shows the number of&nbsp;sent letters, the rate at&nbsp;which they are opened, and the number of&nbsp;candidates&rsquo; responses received.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Tools for working with the calendar',
      items: [
        {
          label: 'Integration with the recruiter&rsquo;s work calendar',
          hint: '<p>Send interview reminders for yourself and your colleagues to&nbsp;the corporate calendar right from Huntflow, without having to&nbsp;switch between apps or&nbsp;tabs.</p>',
          options: [true, true, true],
        },
        {
          label: 'Take into account the time zone of&nbsp;each participant at&nbsp;a&nbsp;meeting',
          hint: '<p>The recruiter sets the time in&nbsp;the time zone of&nbsp;the interview and Huntflow sends a&nbsp;meeting reminder to&nbsp;each participant that takes into account this person&rsquo;s time zone.</p>',
          options: [true, true, true],
        },
        {
          label: 'Automatic attachment of&nbsp;CVs to&nbsp;event with the option of&nbsp;hiding salary expectations',
          hint:
            '<p>Huntflow automatically attaches the candidate&rsquo;s CV&nbsp;to&nbsp;a&nbsp;calendar event. Each interviewer will have the candidate&rsquo;s CV&nbsp;handy to&nbsp;look through before or&nbsp;during the interview.</p>' +
            '<p>If&nbsp;necessary, Huntflow can automatically hide salary expectations in&nbsp;the&nbsp;CV attached to&nbsp;the calendar.</p>',
          options: [true, true, true],
        },
        {
          label: 'Two-way integration with Google Calendar',
          hint:
            '<p>Huntflow offers a&nbsp;comprehensive two-way integration with the corporate Google Calendar.</p>' +
            '<p>Synchronisation of&nbsp;contacts and meeting room reservations, support of&nbsp;private events, and checking whether colleagues and meeting rooms are occupied can all be&nbsp;performed right from Huntflow without switching over to&nbsp;the Calendar app.</p>' +
            '<p>Safe one-click linkup with recruiter&rsquo;s work calendar via OAuth.</p>',
          options: [true, true, true],
        },
        {
          label: 'Two-way integration with Outlook365 calendar',
          hint:
            '<p>Huntflow offers a&nbsp;comprehensive two-way integration with the Outlook365 corporate calendar.</p>' +
            '<p>Synchronisation of&nbsp;contacts and meeting room reservations, support of&nbsp;private events, and checking whether colleagues and meeting rooms are occupied can all be&nbsp;performed right from Huntflow without switching over to&nbsp;the Outlook365 app.</p>' +
            '<p>This unique integration makes it&nbsp;possible to&nbsp;safely connect even internal Outlook365 calendars inaccessible from the outside via the one-click OAuth process.</p>',
          options: [true, true, true],
        },
        {
          label: 'Two-way integration with Exchange calendar',
          hint:
            '<p>Synchronisation of&nbsp;contacts and meeting room reservations, support of&nbsp;private events, and checking whether colleagues and meeting rooms are occupied can all be&nbsp;performed right from Huntflow without switching over to&nbsp;the Calendar app.</p>' +
            '<p>The connection is&nbsp;made via the Exchange Web Services protocol, with use of&nbsp;Impersonation also being possible.</p>',
          options: [true, true, true],
        },
        {
          label: 'Integrated corporate calendar planner',
          hint:
            '<p>Huntflow&rsquo;s integrated calendar planner shows you whether colleagues and meeting rooms are occupied without switching over to&nbsp;the calendar app.</p>' +
            '<p>Works with integrated Google, Outlook365, and Exchange calendars.</p>',
          options: [true, true, true],
        },
        {
          label: 'Integration with Zoom, Google Meet and MS&nbsp;Teams',
          hint: '<p>When a&nbsp;new interview is&nbsp;scheduled, Huntflow will automatically create a&nbsp;video meeting link in&nbsp;Zoom, Google Meet or&nbsp;MS&nbsp;Teams. The link will be&nbsp;attached to&nbsp;the meeting information in&nbsp;the calendars of&nbsp;all the participants and will be&nbsp;added to&nbsp;the candidate&rsquo;s invitation sent by&nbsp;email, text message, or&nbsp;Telegram.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Messengers and IP&nbsp;Telephony',
      items: [
        {
          label: 'Integration with Telegram',
          hint: '<p>Revolutionary integration with Telegram! Huntflow will search for the candidate&rsquo;s Telegram account and offer to&nbsp;send them a&nbsp;message: with or&nbsp;without template.</p>',
          options: [true, true, true],
        },
        {
          label: 'Integration with WhatsApp',
          hint: '<p>Send WhatsApp messages to&nbsp;the candidates without turning your private phonebook into the yellow pages. With Huntflow, you&rsquo;ll only need a&nbsp;couple of&nbsp;clicks to&nbsp;send a&nbsp;message via WhatsApp: with or&nbsp;without template.</p>',
          options: [true, true, true],
        },
        {
          label: 'Integration with Viber',
          hint: '<p>Send Viber messages to&nbsp;the candidates without turning your private phonebook into the yellow pages. With Huntflow, you&rsquo;ll only need a&nbsp;couple of&nbsp;clicks to&nbsp;communicate with candidates on&nbsp;Viber. You must have the Viber app installed on&nbsp;your computer.</p>',
          options: [true, true, true],
        },
        {
          label: 'Integration with Asterisk IP&nbsp;Telephony for outgoing calls to&nbsp;candidates',
          additionalPay: true,
          hint:
            '<p>Call candidates directly from Huntflow. The duration of&nbsp;the call and recording of&nbsp;the conversation, or&nbsp;the fact of&nbsp;a&nbsp;missed call will be&nbsp;saved in&nbsp;the candidate&rsquo;s history.</p>' +
            '<p>Integration: %PRICE%, a one-time payment.</p>',
          options: [null, true, true],
          price: {
            eur: 2900,
          },
        },
      ],
    },
    {
      title: 'Organisation of&nbsp;the business processes',
      items: [
        {
          label: 'Corporate structure dictionary',
          hint: `
            <p>Use corporate structure dictionary&nbsp;to:</p>
            <p>
                <ul>
                    <li>Cover every aspect of&nbsp;the vacancy</li>
                    <li>Collect and analyze detailed data by&nbsp;department or&nbsp;division</li>
                    <li>Conveniently search for candidates who have been considered for vacancies in&nbsp;specific departments</li>
                </ul>
            </p>
          `,
          options: [true, true, true],
        },
        {
          label: 'Configure an&nbsp;unlimited number of&nbsp;stages in&nbsp;the recruitment pipeline',
          hint:
            '<p>There are no&nbsp;limits on&nbsp;the number of&nbsp;recruitment stages you can add to&nbsp;your Huntflow process.</p>' +
            '<p>This is&nbsp;very important: all stages of&nbsp;recruitment present in&nbsp;your real-life business process have to&nbsp;be&nbsp;reflected in&nbsp;the recruitment program. If&nbsp;the software pipeline is&nbsp;different from the real-life pipeline, it&rsquo;s impossible to&nbsp;discover the process&rsquo; pain points.</p>',
          options: [true, true, true],
        },
        {
          label: 'Configure typical rejection reasons',
          hint:
            '<p>Add all the typical rejection reasons that you encounter in&nbsp;the process of&nbsp;recruitment and augment the list as&nbsp;you&nbsp;go.</p>' +
            '<p>Analysing at&nbsp;what stage and for what reason we&nbsp;reject candidates or&nbsp;they reject&nbsp;us helps to&nbsp;discover and correct hidden problems in&nbsp;the recruitment process.</p>' +
            '<p>The number of&nbsp;typical reasons for rejection that you can add to&nbsp;the list is&nbsp;unlimited.</p>',
          options: [true, true, true],
        },
        {
          label: 'Different pipelines for different types of&nbsp;vacancies',
          hint:
            '<p>The recruitment pipeline for simple vacancies is&nbsp;often shorter than the pipeline for top professionals or&nbsp;IT recruitment, whereas the number of&nbsp;stages may be&nbsp;as&nbsp;high as&nbsp;20. </p>' +
            '<p>Use Huntflow to&nbsp;configure different sets of&nbsp;stages (pipelines) for different types of&nbsp;vacancies&nbsp;&mdash; the recruiters&rsquo; work will be&nbsp;made even more convenient, while analytics will become as&nbsp;precise and verifiable as&nbsp;possible.</p>',
          options: [true, true, true],
        },
        {
          label: 'Control (set limits&nbsp;to) the time candidates spend at&nbsp;each stage',
          hint: '<p>Prevent the candidates from &laquo;getting stuck&raquo; at&nbsp;the stages and accelerate their movement through the pipeline by&nbsp;specifying the candidate&rsquo;s target dwell times for each stage.</p>',
          options: [true, true, true],
        },
        {
          label: 'Implementation of&nbsp;additional fields to&nbsp;the vacancy form',
          hint: '<p>We&rsquo;ll add the necessary fields to&nbsp;your vacancy form&nbsp;&mdash; such as&nbsp;&laquo;Grades&raquo;, &laquo;Vacancy category&raquo;, &laquo;Project&raquo;, &laquo;Team&raquo;, and others&nbsp;&mdash; to&nbsp;ensure completeness of&nbsp;information about the vacancy and convenient filtering at&nbsp;the dashboard and in&nbsp;statistics.</p>',
          options: [true, true, true],
        },
        {
          label: 'Implementation of&nbsp;additional fields to&nbsp;the candidate profile',
          hint: '<p>We&rsquo;ll add the necessary fields to&nbsp;the candidate profile, such as&nbsp;&laquo;Previous salary mentioned in&nbsp;the interview&raquo;, &laquo;How the candidate learnt about the vacancy&raquo;, and others.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Recruiters and their rights',
      items: [
        {
          label: 'Prevent deleting of&nbsp;vacancies and candidates',
          hint: '<p>Limit the recruiter&rsquo;s ability to&nbsp;delete candidates as&nbsp;well as&nbsp;to&nbsp;delete and manage vacancies.</p>',
          options: [true, true, true],
        },
        {
          label: 'Hide history of&nbsp;work on&nbsp;vacancies from the recruiter',
          hint:
            '<p>The &laquo;can only see own vacancies&raquo; restriction will hide the vacancies and history of&nbsp;work with candidates for all vacancies save those managed by&nbsp;a&nbsp;given recruiter.</p>' +
            '<p>At&nbsp;the same time, the database of&nbsp;candidates will be&nbsp;fully available, duplicates will be&nbsp;identified, and Huntflow will indicate which particular recruiter is&nbsp;working on&nbsp;a&nbsp;given candidate for the inaccessible vacancy.</p>',
          options: [true, true, true],
        },
        {
          label: 'Option of&nbsp;appointing several Managing Recruiters at&nbsp;Huntflow',
          hint:
            '<p>The role of&nbsp;the Managing Recruiter is&nbsp;an&nbsp;administrative one. The Managing Recruiter manages the list and privileges of&nbsp;the entire team of&nbsp;recruiters and all of&nbsp;the company&rsquo;s settings such as&nbsp;recruitment stages, CV&nbsp;sources, etc.</p>' +
            '<p>If&nbsp;necessary, Managing Recruiter privileges can be&nbsp;given to&nbsp;several of&nbsp;the company&rsquo;s recruiters.</p>',
          options: [true, true, true],
        },
      ],
    },
    {
      title: 'Analytics and reports',
      items: [
        {
          label: 'Dashboard',
          hint: '<p>The dashboard showcases all the open vacancies, number of&nbsp;candidates in&nbsp;the pipeline, time that they spend in&nbsp;the pipeline, and deadlines for filling the positions. It&nbsp;gives you a&nbsp;quick overview of&nbsp;what is&nbsp;happening to&nbsp;the vacancies run by&nbsp;specific departments or&nbsp;specific recruiters.</p>',
          options: [true, true, true],
        },
        {
          label: 'Data visualisation',
          hint: '<p>Huntflow offers unique visualisation of&nbsp;data: a&nbsp;single screen will show you all you need to&nbsp;know about the pipeline, sources, rejections, and their reasons.</p>',
          options: [true, true, true],
        },
        {
          label: 'Download reports to&nbsp;Excel',
          hint: '<p>The reports can be&nbsp;downloaded in&nbsp;Excel format.</p>',
          options: [true, true, true],
        },
        {
          label: 'Reports on&nbsp;the pipeline, sources and rejections',
          hint: '<p>The reports demonstrate the candidates&rsquo; movement through the recruitment pipeline, the sources of&nbsp;candidates, and the reasons for termination of&nbsp;dialogue with a&nbsp;candidate.</p>',
          options: [true, true, true],
        },
        {
          label: 'Report on&nbsp;the time it&nbsp;takes to&nbsp;fill a&nbsp;position﻿',
          hint: '<p>The report shows how many positions were filled with which candidates, how long it&nbsp;took (factoring in&nbsp;weekends), and which recruiters worked with these vacancies.</p>',
          options: [true, true, true],
        },
        {
          label: 'Report on&nbsp;the time candidates spent at&nbsp;each stage',
          hint:
            '<p>The report shows how much time the candidates spent at&nbsp;each stage of&nbsp;the recruitment pipeline. This helps to&nbsp;find and correct those points where candidates get &laquo;stuck&raquo;, whether with the recruiter or&nbsp;the hiring manager.</p>' +
            '<p>The breakdown of&nbsp;data shows how much time specific candidates spent at&nbsp;each stage of&nbsp;recruitment prior to&nbsp;hiring.</p>',
          options: [true, true, true],
        },
        {
          label: 'Detailed analytics with breakdown by&nbsp;candidate',
          hint: '<p>Each segment of&nbsp;the reports&rsquo; visualisation becomes interactive when you click on&nbsp;it. Huntflow will then show the list of&nbsp;candidates incorporated in&nbsp;this segment. You&rsquo;ll see which candidate is&nbsp;stuck at&nbsp;whatever stage, and which has accepted a&nbsp;counteroffer&nbsp;&mdash; and you&rsquo;ll be&nbsp;able to&nbsp;review the candidates&rsquo; profiles in&nbsp;detail so&nbsp;as&nbsp;to&nbsp;better analyse the situation.</p>',
          options: [true, true, true],
        },
        {
          label: 'Report on&nbsp;conversion rates of&nbsp;letters to&nbsp;the candidates',
          hint: '<p>The report shows the number of&nbsp;letters sent, the percentage that were opened, and the number of&nbsp;candidates&rsquo; responses received.</p>',
          options: [true, true, true],
        },
        {
          label: 'Report on&nbsp;candidate movement',
          hint:
            '<p>To&nbsp;fill any vacancy, the recruiter must move the candidates through the pipeline, repeating this each day. With no&nbsp;movement, the vacancy won&rsquo;t be&nbsp;filled. The report on&nbsp;candidate movement will show the daily progress made by&nbsp;recruiters towards the goal of&nbsp;filling the vacancies.</p>' +
            '<p>Management of&nbsp;the recruitment process is&nbsp;impossible without controlling candidate movement.</p>',
          options: [null, true, true],
        },
        {
          label: 'Report on&nbsp;evaluation of&nbsp;recruitment by&nbsp;the hiring managers',
          hint: '<p>This report shows how the hiring managers assess the work of&nbsp;the recruitment department as&nbsp;a&nbsp;whole and specific recruiters in&nbsp;particular (similar to&nbsp;an&nbsp;NPS assessment).</p>',
          options: [null, true, true],
        },
      ],
    },
    {
      title: 'Comfort and care',
      items: [
        {
          label: 'Support chat right in&nbsp;the interface',
          hint:
            '<p>On&nbsp;weekdays, from 5&nbsp;am to&nbsp;4&nbsp;pm UTC, we&nbsp;respond in&nbsp;the support chat found right in&nbsp;the Huntflow interface within a&nbsp;few minutes.</p>' +
            '<p>The common chat with Huntflow Customer Support managers includes all of&nbsp;a&nbsp;customer&rsquo;s recruiters, who can see here the questions posted by&nbsp;their colleagues. This helps avoid the same questions coming up&nbsp;again and again.</p>',
          options: [true, true, true],
        },
        {
          label: 'Notifications about birthdays of&nbsp;candidates for your open vacancies',
          hint: '<p>Once a&nbsp;day, Huntflow sends a&nbsp;letter with reminders about the birthdays of&nbsp;the candidates going through your recruitment process. You&rsquo;ll be&nbsp;able to&nbsp;show some thought and increase your chances of&nbsp;making a&nbsp;successful offer.</p>',
          options: [true, true, true],
        },
        {
          label: 'Interface skins',
          hint: '<p>Make Huntflow feel truly yours! Choose an&nbsp;interface skin to&nbsp;match your taste and mood.</p>',
          options: [true, true, true],
        },
        {
          label: 'Rebrand Huntflow in&nbsp;your corporate style',
          additionalPay: true,
          hint:
            '<p>Having Huntflow branded in&nbsp;your corporate style will imbue the working environment of&nbsp;recruiters and clients with your company&rsquo;s individuality and fill it&nbsp;with corporate spirit. By&nbsp;default, all new users will be&nbsp;given your branded Huntflow skin. The logo in&nbsp;the top left corner will be&nbsp;permanently changed to&nbsp;your company logo even if&nbsp;a&nbsp;recruiter later changes the skin for another offered by&nbsp;Huntflow.</p>' +
            '<p><span class="pricing-table-hint-currency"></span>&nbsp;Deployment: %PRICE%, a&nbsp;one-time payment.</p>',
          options: [true, true, true],
          price: {
            eur: 5900,
          },
        },
      ],
    },
    {
      title: 'Security',
      items: [
        {
          label: 'Free download of&nbsp;the database in&nbsp;the event of&nbsp;business partnership termination',
          hint:
            '<p>We&nbsp;are obliged under the contract to&nbsp;provide for free retrieval of&nbsp;the client&rsquo;s database in&nbsp;the event of&nbsp;business partnership termination.</p>' +
            '<p>The client can choose the format of&nbsp;database retrieval: in&nbsp;the universal computer JSON format with all the links, records, and timelines, or&nbsp;a&nbsp;download of&nbsp;all CVs in&nbsp;PDF or&nbsp;DOCX&nbsp;format.</p>',
          options: [true, true, true],
        },
        {
          label: 'Free backup download of&nbsp;the database on&nbsp;client&rsquo;s request',
          hint: '<p>Free download of&nbsp;the database in&nbsp;JSON format on&nbsp;the client&rsquo;s request, but only once every quarter.</p>',
          options: [true, true, true],
        },
        {
          label: 'Automatic reserve backup of&nbsp;the client&rsquo;s database on&nbsp;SFTP',
          hint: '<p>Organisation of&nbsp;an&nbsp;automatic daily, weekly, monthly, or&nbsp;quarterly upload of&nbsp;your database in&nbsp;JSON format to&nbsp;the SFTP server you provide.</p>',
          options: [null, true, true],
        },
        {
          label: 'Notification of&nbsp;large scale download of&nbsp;CVs by&nbsp;a&nbsp;company employee',
          hint: '<p>Huntflow cares about your data safety. To&nbsp;prevent the theft of&nbsp;the&nbsp;CV database by&nbsp;company employees, use Huntflow to&nbsp;customise daily limits on&nbsp;downloading, printing, and dispatching CVs to&nbsp;email.</p>',
          options: [null, true, true],
        },
      ],
    },
    {
      title: 'Huntflow API',
      items: [
        {
          label: 'API',
          hint:
            '<p>A&nbsp;public API provides infinite possibilities for Huntflow&rsquo;s integration with a&nbsp;company&rsquo;s internal services with the help of&nbsp;your developers.</p>' +
            '<p>Using Huntflow API, our customers deploy integrations with Jira, Slack, career websites, and other features.</p>' +
            '<p><a href="/api" target="_blank">Read more</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Webhooks',
          hint:
            '<p>Webhooks are an integration tool that dispatches data to an external URL when a specific trigger is activated.</p>' +
            '<p><a href="https://github.com/huntflow/api/blob/master/en/webhooks.md" target="_blank">Read more</a></p>',
          options: [true, true, true],
        },
        {
          label: 'Sandbox for testing developed integrations',
          hint: '<p>Provision of&nbsp;a&nbsp;cloud environment for the safe testing of&nbsp;integrations by&nbsp;the client&rsquo;s developers.</p>',
          options: [true, true, true],
        },
        {
          label: 'API methods for automatic addition and removal of&nbsp;users',
          additionalPay: true,
          hint:
            '<p>Provision of&nbsp;API methods for syncing users on&nbsp;the basis of&nbsp;identifiers from the customer&rsquo;s internal system to&nbsp;the customer&rsquo;s developers.</p>' +
            '<p>These methods require hosting Huntflow on&nbsp;a&nbsp;dedicated server and integration with your corporate authentication.</p>' +
            '<p><span class="pricing-table-hint-currency"></span> Cost: %PRICE%, billed annually.</p>',
          options: [null, null, true],
          price: {
            rub: 350000,
            usd: 4900,
            eur: 4300,
            kzt: 2500000,
            uzs: 49500000,
          },
        },
      ],
    },
    {
      title: 'Premier: Solutions for large corporate clients',
      items: [
        {
          label: 'Support for procurement and legal procedures',
          hint: '<p>Large companies have their peculiar procedures for purchasing IT solutions. We fill out the necessary questionnaires and checklists, work under individual contracts, work out personalized terms and conditions, and, upon invitation, make presentations at procurement committees.</p>',
          options: [null, null, true],
        },
        {
          label: 'Customized tech solutions (Private Cloud, On-premise, SSO, mirror, database access)',
          hint: `<p>Meeting your company's IT security requirements:</p>
                <p>
                <ul>
                  <li>Working out the technical architectural layout</li>
                  <li>Hosting Huntflow on dedicated servers in our or your data center</li>
                  <li>Integrating with corporate authentication</li>
                  <li>Performing IT audit and penetration tests</li>
                  <li>Deploying and maintaining a mirror for testing implementations and integrations</li>
                  <li>Providing access to your Huntflow database for your data analysts</li>
                <ul></p>`,
          options: [null, null, true],
        },
        {
          label: 'Conducting a workshop to come up with an optimal deployment plan for Huntflow',
          hint: `<p>We organize a workshop that is attended by our implementation manager, project manager, and IT specialist. The workshop ends with the approval of a project architecture and launch plan with dates and risk considerations</p>`,
          options: [null, null, true],
        },
        {
          label: 'Splitting recruiters into teams',
          hint: '<p>Huntflow makes it&nbsp;possible to&nbsp;organise recruiters into teams, each with its own team leader. This is&nbsp;necessary for convenient filtering of&nbsp;recruiters on&nbsp;the dashboard and in&nbsp;statistical reports.</p>',
          options: [null, null, true],
        },
        {
          label: 'Restricting access to information depending on the department',
          hint:
            '<p>For each recruiter, you can specify the department or&nbsp;subdivision for which they recruit employees.</p>' +
            '<p>The recruiter will only see the requests, vacancies, clients, and letter templates for this specific subdivision, without having to&nbsp;select them from the comprehensive list for the whole company.</p>',
          options: [null, null, true],
        },
        {
          label: 'Personal account manager',
          hint: '<p>Issues of cooperation are discussed with your assigned personal account manager</p>',
          options: [null, null, true],
        },
        {
          label: 'Privilege advanced customer support',
          hint: "<p>Answers to recruiters' questions via built-in chat or email with top priority and extended time range from 6:00 to 22:00 Moscow time</p>",
          options: [null, null, true],
        },
        {
          label: 'A dedicated line for API technical consulting',
          hint: '<p>Personalized consulting for your developers on the best architecture for integrations and use of Huntflow API </p>',
          options: [null, null, true],
        },
      ],
    },
  ],
};
